import Calendar from "react-calendar";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@/store/store";
import { setGlobalDate } from "@/store/schedule/scheduleSlice";

import { toggleVisibilityCalendarInScheduleHeader } from "@/store/ui/ui";
import {
    updateNewAppointment,
    updateExistAppointment,
} from "@/store/appointments/appointmentsSlice";
import { dateFormatter } from "@/utils/dateFormatter";
import { setPatientsBirthDay } from "@/store/patients/patients";

import { IconCalendarProps } from "@/shared/interfaces/patientPage";

import "./Calendar.scss";

export default function CalendarComponent({ text }: IconCalendarProps) {
    const dispatch = useDispatch();
    const isVisibleCalendar = useSelector(
        (state: RootState) => state.ui.isVisibleCalendarInSheduleHeader,
    );
    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );
    const activeCategoryInNav = useSelector(
        (state: RootState) => state.ui.activeCategoryInNav,
    );

    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );
    const patientId = useSelector(
        (state: RootState) => state.patients.patientId,
    );    

    useEffect(() => {
        const formattedDate = dateFormatter(new Date(globalDate));
        const action = isEditAppointment
            ? updateExistAppointment
            : updateNewAppointment;

        dispatch(action({ date: formattedDate }));
    }, [globalDate, dispatch, isEditAppointment]);

    return (
        <>
            {isVisibleCalendar ? (
                <Calendar
                    formatMonthYear={(locale, date) =>
                        date
                            .toLocaleDateString("uk-UA", {
                                month: "long",
                                year: "numeric",
                            })
                            .replace(" р.", "")
                    }
                    prevLabel={
                        <img src='/calendar/left.svg' alt='Назад' width={24} />
                    }
                    prev2Label={
                        <img
                            src='/calendar/doble-left.svg'
                            alt='Назад'
                            width={24}
                        />
                    }
                    nextLabel={
                        <img src='/calendar/right.svg' alt='Назад' width={24} />
                    }
                    next2Label={
                        <img
                            src='/calendar/doble-right.svg'
                            alt='Назад'
                            width={24}
                        />
                    }
                    className={`schedule_header_calendar appointmen_placed
                         ${
                             activeCategoryInNav === "schedule"
                                 ? "shedule_placed"
                                 : "appointmen_placed"
                         }
                                  ${
                                      activeCategoryInNav === "statistic"
                                          ? "stats_placed"
                                          : ""
                                  }
                        `}
                    onChange={value => {
                        if (value instanceof Date) {
                            const localDate = new Date(value);
                            localDate.setHours(0, 0, 0, 0);
                            const localDateString =
                                localDate.toLocaleDateString("en-CA");
                            const formattedDate = `${localDateString}T00:00:00.000+00:00`;
                            dispatch(
                                (text === "Дата народження"
                                    ? setPatientsBirthDay
                                    : setGlobalDate)(formattedDate),
                            );
                        }
                        dispatch(
                            toggleVisibilityCalendarInScheduleHeader(false),
                        );
                    }}
                    value={new Date(globalDate)}
                    formatDay={(locale: string | undefined, actualDate: Date) =>
                        actualDate.getDate().toString()
                    }
                    locale='uk-UA'
                />
            ) : null}
        </>
    );
}
